import React from "react";
import Common from "./common";
import style from "css/lecture.module.css";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { useDispatch } from "react-redux";
import { openPopup } from "redux/slices/drawerPopupSlice";
import NeatPopup from "components/device/neat/neatPopup";

function Lab() {
  //dispatch
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const HeaderInfo = {
    subTitle: "Hybrid Smart Lab",
    title: "하이브리드 스마트 실습실",
    info: [
      <font>
        물리적 실습과 온라인 실습을 결합한{"\n"} 하이브리드 학습 모델을 통해,{" "}
        <br />
        학생들은 언제 어디서나 실습에 참여할 수 있습니다. <br /> 이는 장소에
        구애받지 않고{"\n"} 유연하게 학습할 수 있는 환경을 제공합니다.
      </font>,
    ],
    img: "img/smartspace/labImg1.png",
    img_m: "img/smartspace/labImg1_m.png",
  };

  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                하이브리드 스마트 실습실에서 뛰어난 화상 회의 경험을 제공하는 AI
                기반의 화상 장비로,
              </font>
              <font>
                다양한 기능을 통해{" "}
                <label style={{ color: "#062ff9" }}>
                  교수와 학생, 원격지 간의{" "}
                </label>
                상호작용을 극대화합니다.
              </font>
            </>
          ) : (
            <>
              <font>
                하이브리드 스마트 실습실에서 뛰어난 화상 회의 경험을 제공하는 AI
                기반의 화상 장비로, 다양한 기능을 통해{"\n"}
                <label style={{ color: "#062ff9" }}>
                  교수와 학생, 원격지 간의{" "}
                </label>
                상호작용을 극대화합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "AI 화상 장비 ( AI remote learning device )",
      img: "img/smartspace/labImg2.png",
      img_m: "img/smartspace/labImg2_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                AI 화상장비의 Boundary 기능은 프레임 공간을 설정하면 공간 안의
                사용자만을
              </font>
              <font>
                집중합니다. 공간 외의 사용자를 팔로우 하는 것을 방지 합니다.
              </font>
              <font>
                각 그룹에 배치된 화상장비는 그룹안의 사용자에게만 집중하도록
                비디오,오디오가
              </font>
              <font>컨트롤 됩니다.</font>
            </>
          ) : (
            <>
              <font>
                AI 화상장비의 Boundary 기능은 프레임 공간을 설정하면 공간 안의
                사용자만을 집중합니다. 공간 외의 사용자를 팔로우 하는 것을 방지
                합니다.{"\n"} 각 그룹에 배치된 화상장비는 그룹안의 사용자에게만
                집중하도록 비디오,오디오가 컨트롤 됩니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "그룹에 집중할 수 있는 Boundary 기술 ( Boundary )",
      img: "img/smartspace/labImg3.png",
      img_m: "img/smartspace/labImg3_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                강의실 내 모든 디지털 장비(프로젝터·스마트
                보드·카메라·마이크·조명 등)를
              </font>
              <font>
                하나의 인터페이스에서 통합적으로 제어할 수 있는 소프트웨어
                프로그램 입니다.
              </font>
            </>
          ) : (
            <>
              <font>
                강의실 내 모든 디지털 장비(프로젝터·스마트
                보드·카메라·마이크·조명 등)를 하나의 인터페이스에서 통합적으로
                제어할 수 있는 소프트웨어 프로그램 입니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "스마트 강의 컨트롤 시스템",
      img: "img/smartspace/labImg4.png",
      img_m: "img/smartspace/labImg4_m.png",
    },
  ];

  const BodyFooter = [
    {
      id: 1,
      txt: "산업 전문가와 기업 멘토의 참여를 통해 실무 중심의 교육을 제공하며, 학생들이 실제 산업 현장에서 요구되는 기술과 지식을 습득할 수 있도록 합니다. 이는 졸업 후 취업 준비에 큰 도움이 됩니다.",
      title: (
        <p>
          <font>실무 중심</font>의 교육{" "}
        </p>
      ),
    },
    {
      id: 2,
      txt: "하이브리드 학습 모델을 통해 학생들은 물리적 공간의 제약을 극복하고, 언제 어디서나 실습에 참여할 수 있습니다. 이는 학습의 접근성과 유연성을 높이며, 다양한 학습 스타일에 맞춘 교육을 가능하게 합니다.",
      title: (
        <p>
          <font>유연성과 접근성 </font>향상
        </p>
      ),
    },
    {
      id: 3,
      txt: "다양한 협업 도구와 실습 환경을 통해 학생들은 창의적이고 유연하게 문제를 해결할 수 있는 능력을 기를 수 있습니다. 이는 미래의 복잡한 문제를 해결하는 데 필요한 핵심 역량을 개발하는 데 도움이 됩니다.",
      title: <p>창의적 문제 해결 능력 강화</p>,
    },
  ];
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg2.png",
      title: "스마트 강의 컨트롤 시스템",
      txt: "스마트 강의 컨트롤 시스템은 강의실 내 장비와 디지털 콘텐츠를 통합\n관리하여, 교수와 학생 모두에게 최적화된 학습 환경을 제공합니다.\n실시간 강의, 화면 공유, 출석 관리 등을 손쉽게 운영할 수 있으며,\n하이브리드 수업에 효과적으로 대응할 수 있도록 설계되었습니다.",
      onClick: () => showDrawer("deviceone"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_frame.png",
      title: "화상회의 장비 neat.frame",
      txt: "컴팩트한 사이즈와 고성능 카메라를 탑재한 Neat Frame은 작은 공간에서도 깔끔하게 배치·이동할 수 있어 유연한 연구 환경을 지원합니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };
  const BodyHeader = (
    <div className={style.bodyTitle}>
      <p>실습을 통한 실무 중심 교육</p>
      <p>
        실습 중심의{"\n"} 혁신적 학습 환경을 위한{"\n"} 하이브리드 스마트 실습실
      </p>
      <p>
        최첨단 장비와 기술을 활용한 실습 환경 <br /> 산업 전문가 및 기업 멘토의
        참여로 창의적이고{"\n"} 유연한 실습 가능
      </p>
    </div>
  );
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      <p>Riv Technology의{"\n"} 하이브리드 실습실 구축은 </p>
      <p>
        <font>실습실 환경에 맞춰 설계</font>되어,
      </p>
      <p>
        교수와 학생에게{"\n"} <font>혁신적인 학습 환경</font>을 제공합니다.
      </p>
    </div>
  );
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      하이브리드 실습실 <font>구성 환경</font>
    </div>
  );

  return (
    <>
      <SEOMeta
        title="하이브리드 스마트 실습실, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 하이브리드 스마트 실습실"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 하이브리드 스마트 실습실"
      />
      <NeatPopup />
      <div>
        <Common
          headerInfo={HeaderInfo}
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
      </div>
    </>
  );
}

export default Lab;
